export const ApiConfig = {
  url: "https://api.paulthibault.fr/wp-json/",
  // url:
  //   process.env.NODE_ENV === 'production'
  //     ? 'http://api.paulthibault.fr/wp-json/'
  //     : 'http://localhost:8888/freelance/paul-thibault/PAUL_THIBAULT-API_2017/wp-json/'
};



// WEBPACK FOOTER //
// ./src/util/Config.js